import React from "react";
import PropTypes from "prop-types";
import { I18n, Translate } from "react-redux-i18n";
import { Flex, Label } from "rebass";
import styled from "styled-components";
import { space, width } from "styled-system";
import { PvBox, PvButton, PvInput } from "styles/CustomComponents";
import { formatCourse } from "../../util/FormatUtil";
import Error from "components/Error";

const PvSearchBtn = styled(PvButton)`
  ${space}
  ${width}
`;

class CourseSelectForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newCourse: Object.assign({}, props.defaultCourse, props.currentCourse),
    };
  }

  selectDisabled = (course) => {
    return !(
      !!course &&
      !!course.courseNumber &&
      !!course.courseYear &&
      !!course.courseUnit
    );
  };

  updateCourse = (event) => {
    this.setState({
      newCourse: Object.assign({}, this.state.newCourse, {
        [event.target.name]: event.target.value,
      }),
    });
  };

  render() {
    const { currentCourse, selectCourse, courseData } = this.props;
    const { newCourse } = this.state;

    return (
      <PvBox my={2}>
        <Flex flexWrap="wrap" alignItems="flex-end">
          <PvBox display="inline-block" px={2} my={2} w={[1]}>
            {currentCourse ? (
              <div>
                <Label mb={2}>
                  <Translate value="course.selected_course" />
                </Label>
                {courseData && courseData.error ? (
                  <Error
                    message={
                      courseData.error.status === 404
                        ? I18n.t("course.not_found")
                        : courseData.error.message
                    }
                  />
                ) : (
                  formatCourse(currentCourse)
                )}
              </div>
            ) : (
              <Translate value="course.no_selection" />
            )}
          </PvBox>
          <PvBox display="inline-block" px={2} w={[1 / 3, 1 / 3, 1 / 8]}>
            <Label mb={2}>
              <Translate value="search.course_number" />
            </Label>
            <PvInput
              py={3}
              name="courseNumber"
              onChange={this.updateCourse}
              value={newCourse.courseNumber}
            />
          </PvBox>
          <PvBox display="inline-block" px={2} w={[1 / 3, 1 / 3, 1 / 8]}>
            <Label mb={2}>
              <Translate value="search.course_year" />
            </Label>
            <PvInput
              name="courseYear"
              onChange={this.updateCourse}
              value={newCourse.courseYear}
            />
          </PvBox>

          <PvBox display="inline-block" px={2} w={[1 / 3, 1 / 3, 1 / 8]}>
            <Label mb={2}>
              <Translate value="search.course_unit" />
            </Label>
            <PvInput
              name="courseUnit"
              onChange={this.updateCourse}
              value={newCourse.courseUnit}
            />
          </PvBox>
          <PvBox display="inline-block" px={2} py={[2, 2, 0]} w={[1, 1, 2 / 8]}>
            <PvSearchBtn
              px={3}
              width="100%"
              disabled={this.selectDisabled(newCourse)}
              onClick={(e) => {
                e.preventDefault();
                selectCourse(newCourse);
              }}
            >
              <Translate value="course.select" />
            </PvSearchBtn>
          </PvBox>
        </Flex>
      </PvBox>
    );
  }
}

CourseSelectForm.propTypes = {
  currentCourse: PropTypes.object,
  defaultCourse: PropTypes.object,
  selectCourse: PropTypes.func,
  courseData: PropTypes.object,
};

export default CourseSelectForm;



// WEBPACK FOOTER //
// ./src/containers/course/CourseSelectForm.jsx